import { isNaN as _isNaN, isNumber, toNumber } from "lodash";
import { useCallback, useMemo } from "react";

const defaultOptions: Intl.NumberFormatOptions = {
  style: "currency",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const useFormatCurrency = (options: Intl.NumberFormatOptions = {}) => {
  const getValueWithCurrency = useCallback(
    (value: null | undefined | number, currencyToOverride?: string) => {
      const currency = currencyToOverride || options.currency;
      if (!currency) return "";

      if (value !== null && typeof value !== "undefined") {
        if (isNumber(value)) {
          return new Intl.NumberFormat("fi", {
            ...defaultOptions,
            ...options,
            currency,
          }).format(value);
        }
        const valueToNumber = toNumber(value);

        if (_isNaN(valueToNumber)) {
          return "";
        }
        return new Intl.NumberFormat("fi", {
          ...defaultOptions,
          ...options,
        }).format(valueToNumber);
      }
      return "";
    },
    [options],
  );

  const currency = useMemo(() => {
    if (!options.currency) return null;

    return (
      new Intl.NumberFormat("fi", { ...defaultOptions, ...options })
        .formatToParts(undefined)
        .find(({ type }) => type === "currency")?.value || null
    );
  }, [options]);

  return [getValueWithCurrency, currency] as const;
};
